import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";

type AcademicPeriodRecord = {
    mshied_academicperiodid: string;
    mshied_name: string;
};

export const useGetAcademicSessionName = () => {
    const { user, siteId } = useAuth();
    const [readRecords] = useLazyReadMultipleQuery();
    const [academicPeriodMap, setAcademicPeriodMap] = useState<Map<string, string>>(new Map());
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchAcademicPeriods = async () => {
            if (!user?.userId || !siteId) return;

            try {
                const result = await readRecords({
                    userId: user?.contactId || '',
                    portalId: siteId,
                    tableId: "mshied_academicperiod",
                    fieldList: ["mshied_academicperiodid", "mshied_name"],
                    filters: []
                }).unwrap();

                const records = (result.records || []) as AcademicPeriodRecord[];
                const lookupMap = new Map<string, string>(
                    records.map((record) => [record.mshied_academicperiodid, record.mshied_name])
                );
                setAcademicPeriodMap(lookupMap);
            } catch (err) {
                console.error("Failed to fetch academic period names:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAcademicPeriods();
    }, [user?.userId, siteId, readRecords]);

    const getAcademicPeriodName = (id: string): string => {
        return academicPeriodMap.get(id) || "";
    };

    return { getAcademicPeriodName, isLoading };
};